import { forwardRef, type ChangeEvent } from 'react';

import { datetimeLocalInputToIso, isoToDatetimeLocalInput } from '@/shared/utils/date';
import { cn } from '@/shared/utils/cn';

import { Input, type InputProps } from './Input';

export interface IstNativeDateTimeFieldProps
  extends Omit<InputProps, 'type' | 'value' | 'onChange' | 'defaultValue'> {
  /** API ISO string (or empty). */
  value: string;
  onChange: (iso: string) => void;
}

/**
 * Native browser datetime picker (`datetime-local`) in IST wall clock.
 * Emits ISO for the API. Used on coupon, promotion, and kit forms.
 */
export const IstNativeDateTimeField = forwardRef<HTMLInputElement, IstNativeDateTimeFieldProps>(
  function IstNativeDateTimeField(
    { value, onChange, onBlur, disabled, invalid, className, ...rest },
    ref,
  ) {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const next = e.target.value;
      if (!next) {
        onChange('');
        return;
      }
      onChange(datetimeLocalInputToIso(next));
    };

    return (
      <Input
        ref={ref}
        type="datetime-local"
        autoComplete="off"
        disabled={disabled}
        invalid={invalid}
        value={isoToDatetimeLocalInput(value)}
        onChange={handleChange}
        onBlur={onBlur}
        className={cn('min-h-9 items-center', className)}
        {...rest}
      />
    );
  },
);
